import React from "react";
import { complaintTypesService, complaintStatusService, usersCachingService, stagesService, } from "../../services";
import { CaseSearch } from "./CaseSearch";
import { CaseAllocation } from "../analyticsDashboard/CaseAllocation";
import { FilterList } from "@material-ui/icons";
import { FilterMenu } from "@ofqual/portal-components/components/ResponseFilter";
import { makeStyles, MenuItem } from "@material-ui/core";
import { SelectListField } from "../common/SelectListField";
import { ensureParamIsArray } from "@ofqual/portal-core/core/utils/urlHelper";
import { DatePicker } from "@ofqual/portal-components/components/DatePicker";
const COMPLAINTS_TEAM_ID = "complaints";
const useStyles = makeStyles((theme) => {
    return {
        root: {
            "& fieldset": {
                borderColor: theme.palette.primary.main,
            },
        },
        menuItem: {
            "&:hover": {
                backgroundColor: "transparent",
            },
        },
        menuText: {
            marginBottom: 0,
        },
    };
});
export const FilterControls = ({ navigate, params, searchParamsFiltersOnly, }) => {
    const classes = useStyles();
    return (React.createElement(React.Fragment, null,
        "\u00A0",
        React.createElement(CaseSearch, { navigate: navigate, params: params }),
        "\u00A0",
        React.createElement(FilterMenu, { Icon: FilterList, title: "FILTERS", dataTest: "cwm-filter-menu", search: { searchParamsFiltersOnly, navigateToNextSearch: navigate } }, (workingParams, dirtyParams, addParam, updateMultipleParams) => (React.createElement("form", null,
            React.createElement(MenuItem, { className: classes.menuItem },
                React.createElement(SelectListField, { label: "Case Type", dataTest: "filter-case-type", service: complaintTypesService, name: "casetype", value: workingParams.casetype, onChange: (e) => addParam("casetype", e.target.value), onBlur: () => { } })),
            React.createElement(MenuItem, { className: classes.menuItem },
                React.createElement(SelectListField, { label: "Status", dataTest: "filter-case-status", service: complaintStatusService, name: "status", value: workingParams.status, onChange: (e) => addParam("status", e.target.value), onBlur: () => { } })),
            React.createElement(MenuItem, { className: classes.menuItem },
                React.createElement(SelectListField, { label: "Case lead", dataTest: "filter-case-lead", service: {
                        getAll: () => usersCachingService.getAll({ teamId: COMPLAINTS_TEAM_ID }).then(response => {
                            response.data = [{ id: "unassigned", name: "Unassigned" }, ...response.data];
                            return response;
                        }),
                    }, name: "assigned", value: ensureParamIsArray(workingParams.assigned), multiple: true, onChange: (e) => addParam("assigned", e.target.value), onBlur: () => { } })),
            React.createElement(MenuItem, { className: classes.menuItem },
                React.createElement(SelectListField, { label: "Case stage", dataTest: "filter-case-stage", service: stagesService, name: "stage", value: ensureParamIsArray(workingParams.stage), onChange: (e) => addParam("stage", e.target.value), onBlur: () => { }, multiple: true })),
            React.createElement(MenuItem, { className: classes.menuItem },
                React.createElement(DatePicker, { label: "Received From:", value: workingParams.receivedFrom || null, onChange: (val) => addParam("receivedFrom", val), onClear: () => addParam("receivedFrom", undefined), returnDayBoundary: "startOfDay", dataTest: "received-from-filter" })),
            React.createElement(MenuItem, { className: classes.menuItem },
                React.createElement(DatePicker, { label: "Received To:", value: workingParams.receivedTo || null, onChange: (val) => addParam("receivedTo", val), onClear: () => addParam("receivedTo", undefined), returnDayBoundary: "endOfDay", dataTest: "received-to-filter" }))))),
        "\u00A0",
        React.createElement(CaseAllocation, null)));
};
